module.exports = __webpack_public_path__ + "static/media/Me.fa868f04.png";